module.exports = __webpack_public_path__ + "static/media/hp_16.b9cba065.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_16.jpg
// module id = 5827
// module chunks = 0